<template>
  <v-snackbar
    v-model="show"
    :color="color"
    multi-line="multi-line"
    location="top right"
    :timeout="6000"
  >
    {{ message }}
  </v-snackbar>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      show: false,
      message: "",
      color: "info",
    };
  },
  created() {
    this.$store.watch(
      (state) => state.snackbar.snack,
      () => {
        const msg = this.snack;
        if (msg !== "") {
          this.show = true;
          this.message = msg.message;
          this.color = msg.color;
          this.$store.commit("setSnack", "");
        }
      }
    );
  },
  computed: {
    ...mapGetters(["snack"]),
  },
};
</script>